import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";

import FilterForm from "app/Components/FilterForm/FilterForm";
import {
  useArea,
  useCategory,
  useContractorPerson,
  useEmployee,
  useTraining,
} from "app/_helpers/hooks";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
//import { UserService } from "app/_services/UserService/UserService";
//import { LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";
import { LOGGED_IN_USER_SITE_ID } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { UserService } from "app/_services/UserService/UserService";
// import { TRAINEE_TYPE, trainingStatusFilterFields } from "../../CONSTANTS";
import { userFilterFields } from "./helper";
import { RoleService } from "app/_services/RoleService/RoleService";

export default function UserFilters({ form, onChange, onReset, setForm }) {
  const [state, setState] = useState({
    sites: [],
  });

  const [, trainingOption] = useTraining("filter[type]=training");
  const [roles, setRoles] = useState([]);

  const [nameList, setNameList] = useState([]);

  // useEffect(() => {
  //   setNameList(
  //     form?.traineeTypeView === TRAINEE_TYPE.employee
  //       ? [...employeesOption]
  //       : form?.traineeTypeView === TRAINEE_TYPE.contractorPerson
  //       ? [...contractorPersonsOption]
  //       : [...employeesOption, ...contractorPersonsOption]
  //   );
  // }, [contractorPersonsOption, employeesOption, form?.traineeTypeView]);

  useEffect(() => {
    getAllSites("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setState((prev) => ({
        ...prev,
        //initialActivity: response?.data,
        sites: response.data.map((row) => ({ label: row.name, value: row.id })),
      }));
    });

    RoleService.RoleList().then((response) => {
      if (!response?.data) return;

      setRoles(response?.data?.roles.map((d) => ({ label: d.title, value: d.id })));
    });
  }, []);

  const fields = useMemo(
    () =>
      userFilterFields.map((f) => {
        const field = { ...f };
        switch (field.name) {
          case "siteId":
            field.options = state.sites;
            break;
          case "siteIdEmp":
            field.options = state.sites;
            break;
          case "trainingDesignation":
            field.options = trainingOption;
            break;
          case "roleId":
            field.options = roles;
            break;

          default:
            break;
        }

        return field;
      }),
    [roles, state.sites, trainingOption]
  );

  return (
    <div className="pb-4">
      <FilterForm fields={fields} form={form} onChange={onChange} onReset={onReset} />
    </div>
  );
}
